import { BOOK_COVER_IMAGE, BOOK_TAGLINE } from "@/content";

// Typographic placeholder cover. When the final cover is supplied,
// set BOOK_COVER_IMAGE in src/content.js and it renders instead.
const BookCover = ({ className = "" }) => {
  if (BOOK_COVER_IMAGE) {
    return (
      <img
        src={BOOK_COVER_IMAGE}
        alt="REGULATE book cover"
        data-testid="book-cover-image"
        className={`w-full h-auto ${className}`}
      />
    );
  }
  return (
    <div
      data-testid="book-cover-placeholder"
      className={`relative aspect-[2/3] w-full bg-teal text-ivory border border-stone/40 shadow-[0_30px_60px_-30px_rgba(76,144,128,0.5)] ${className}`}
    >
      <div className="absolute inset-3 border border-ivory/20" aria-hidden="true" />
      <div className="absolute inset-0 flex flex-col items-center justify-between py-10 md:py-12 px-6 text-center">
        <p className="font-sans text-[10px] md:text-xs uppercase tracking-[0.4em] text-ivory/70">
          Tara Aurora
        </p>
        <div>
          <p className="font-serif text-3xl md:text-[2rem] lg:text-[2.35rem] tracking-[0.08em] whitespace-nowrap">REGULATE</p>
          <div className="mx-auto mt-5 h-px w-10 bg-ivory/70" aria-hidden="true" />
          <p className="mt-5 font-serif italic text-sm md:text-base text-ivory/80 leading-relaxed max-w-[220px] mx-auto">
            {BOOK_TAGLINE}
          </p>
        </div>
        <p className="font-sans text-[9px] md:text-[10px] uppercase tracking-[0.3em] text-ivory/50">
          Cover artwork coming soon
        </p>
      </div>
    </div>
  );
};

export default BookCover;
